import React from 'react';
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import Pricing from './components/Pricing/Pricing';
import Footer from './components/Footer/Footer';
import './App.css';

const App = () => {
  return (
    <>
      <Navbar />
      <Hero />
      {/* <Pricing /> */}
      <Footer />
    </>
  );
};

export default App; 